import { distance } from 'fastest-levenshtein';

export function getLevenshteinDistance(a: string, b: string): number {
	return distance(a, b);
}

export function sortByRelevance<T>({
	array,
	search,
	orderByValue
}: {
	readonly array: readonly T[];
	readonly search: string;
	readonly orderByValue: (item: T) => string;
}): readonly T[] {
	return array.toSorted((a, b) => {
		return getLevenshteinDistance(orderByValue(a), search) - getLevenshteinDistance(orderByValue(b), search);
	});
}
